import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, Box, ButtonGroup, Typography, useMediaQuery, Card, CardHeader, CardContent, CardActions, CardActionArea, Rating, Button, Collapse, useTheme, InputBase, IconButton, Divider, styled, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction } from "@mui/material"
import Header from './Header'
import { UserAuth } from '../context/AuthContext'
import { useNavigate, useParams } from 'react-router-dom'
import { motion } from "framer-motion";
import Grid from '@mui/material/Unstable_Grid2';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TokenContext from '../context/TokenContext';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { biografia, infoEvento, limpiarInformacion } from '../Redux/universidadInterna'
import { COLUMNSEVENTO } from '../columnas/columnasInfo'
import TablaInfo from './tablas/TablaInfo'

const InformacionEventos = () => {
    const dispatch = useDispatch()
    const theme = useTheme()
    const navigate = useNavigate();
    const token = useContext(TokenContext)
    const { id } = useParams()
    const { empleado } = UserAuth()

    const [info, setInfo] = React.useState([])
    const [loadingInfo, setLoadingInfo] = React.useState(false)
    const infoSelector = useSelector(store => store.universidadInterna.infoEvento)
    const getEventoselector = useSelector(store => store.universidadInterna.getInfoEvento)

    const [bio, setBio] = React.useState('')
    const [loadingBio, setLoadingBio] = React.useState(false)
    const bioSelector = useSelector(store => store.universidadInterna.bio)
    const getBIOelector = useSelector(store => store.universidadInterna.getBio)

    React.useEffect(() => {
        // Función de limpieza
        return () => {
            dispatch(limpiarInformacion());
        };
    }, []);

    React.useEffect(() => {
        if (token && empleado) {
            dispatch(infoEvento(token, empleado.usuarioPortalRh, id))
            dispatch(biografia(token, id))
        }
    }, [id, token, empleado])

    //INFORMACION EVENTO
    React.useEffect(() => {
        if (infoSelector?.length > 0 && getEventoselector === true) {
            var array = []
            infoSelector.forEach(element => {
                var objeto = {
                    id: element.new_participanteporeventodecapacitacionid,
                    new_duracionenhoras: element["ab.new_duracionenhoras"],
                    new_modalidaddecurso: element["ab.new_modalidaddecurso@OData.Community.Display.V1.FormattedValue"],
                    new_sede: element["ab.new_sede@OData.Community.Display.V1.FormattedValue"],
                    new_fechainicio: element["ab.new_fechainicio@OData.Community.Display.V1.FormattedValue"],
                    new_fechafinalizacion: element["ab.new_fechafinalizacion@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setInfo(array)
            setLoadingInfo(true)
        } else if (infoSelector?.length == 0 && getEventoselector === true) {
            setLoadingInfo(true)
        }
    }, [infoSelector, id])

    //BIO
    React.useEffect(() => {
        if (bioSelector?.length > 0 && getBIOelector === true) {
            // Acceder al valor de 'ac.new_bio' del primer objeto en el array
            const acNewBioValue = bioSelector[0]["ac.new_bio"];
            setBio(acNewBioValue)
            setLoadingBio(true)
        } else if (bioSelector?.length == 0 && getBIOelector === true) {
            setLoadingBio(true)
        }
    }, [bioSelector, id])

    const handleVolverAtras = () => {
        navigate('/universidad-interna');
    };
    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box
                m="1.5rem 2.5rem"
            >
                <Button variant="outlined" onClick={handleVolverAtras} sx={{ mb: 4 }} color='secondary'>
                    <IconButton color='secondary'>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography color='secondary'>Volver atrás</Typography>
                </Button>

                <Header title={"Información de eventos"} subtitle="" />

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <Typography variant="h5" color={theme.palette.secondary[300]} sx={{ fontWeight: 'bold', mt: 2 }}>
                            {bio}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        {
                            !loadingInfo ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: '100%',
                                        py: 2
                                    }}>
                                    <CircularProgress color="secondary" />
                                </Box>
                            ) :
                                info.length > 0 ? (
                                    <>
                                        <TablaInfo columnas={COLUMNSEVENTO} lineas={info} />
                                    </>
                                ) :
                                    <Alert severity="info">
                                        <AlertTitle>Info</AlertTitle>
                                        No existen registros de — <strong>Información de eventos</strong>.
                                    </Alert>
                        }
                    </Grid>
                </Grid>
            </Box>
        </motion.div>
    )
}

export default InformacionEventos